import styled from 'styled-components/macro';

export const InstructionsContainer = styled.div`
  margin-bottom: 50px;
`;
